export const transactionStatus = {
    PENDING: "PENDING",
    FINISHED: "FINISHED",
    CANCELLED: "CANCELLED",
    SCHEDULED: "SCHEDULED",
    PROCESSING: "PROCESSING",
    FAILED: "FAILED",
    AWAITING: "AWAITING",
    PENDING_BACKOFFICE: "PENDING_BACKOFFICE",
    FINISHED_WITH_ERRORS: "FINISHED_WITH_ERRORS",
};

export const codeStates = {
    COR023I: transactionStatus.PENDING,
    COR000I: transactionStatus.FINISHED,
    COR013I: transactionStatus.SCHEDULED,
    BAK599E: transactionStatus.FAILED,
    API517I: transactionStatus.AWAITING,
};

export const getStateByCode = (code) => {
    const isFinished = code === "COR000I";
    const isPending = code === "COR023I";
    const hasValidationError = code === "COR020W";
    const isWarning = code.endsWith("W");
    const isError = code.endsWith("E");
    const isInfo = code.endsWith("I");
    const category = { isWarning, isError, isInfo };

    return { isFinished, isPending, hasValidationError, category };
};

export const getRouteByState = (status, routeParam = "") => {
    if (status === transactionStatus.PENDING) {
        return {
            "request.account.send": "/accounts/pendingTransaction",
            "request.agreement.send": "/accounts/agreements/pendingTransaction",
            "request.deposit.send": "/deposits/pendingTransaction",
            "request.accountsCheckbook.send": "/checks/pendingUserSignatures",
            "deposit.cancelRenewal.send": "/deposits/cancelRenewal/pendingTransaction",
            "emit.echeq.activity": "/echecks/emit/pending",
            "transmit.cedip.send": "/cedip/transmit/pending",
            "transmit.admit.cedip.send": "/cedip/transmit/admit/pending",
            "transmit.anulate.cedip.send": "/cedip/transmit/anulate/pending",
            "transmit.repudiate.cedip.send": "/cedip/transmit/repudiate/pending",
            "endorse.echeq.activity": "/echecks/action/endorse/pending",
            "cesion.echeq.activity": "/echecks/action/cesion/pending",
            "actions.echeqs.send": "/echecks/action/transaction/pending",
            "echeq.request-return.action": "/echecks/return/pending",
            "accept.return.echeqs": "/echecks/return/pending",
            "load.debin.recurrency": "/debin/emit/pending",
            "generate.transfer": `/transfers/${"internal"}/pending`,
            "generate.transfer.third.party": `/transfers/${"other"}/pending`,
            "destinations.create": "/contactDestination/pending",
            "transfers.third.parties": "/lotPayments/newPayment/pending",
            "echeq.updateAmount": "/echecks/requestAmount/pending",
            "debin.create.send": "/debinPayments/solicitDebin/pending",
            "debin.incoming.accept.send": "/debinPayments/pay/pending",
            "echeq.aval.solicitar": "/echecks/aval/solicit/pending",
            "load.echeq.massive": "/massiveEchecks/newEcheq/pending",
            "echeq.aval-anulate.action": "/echecks/aval/update/pending",
            "echeq.aval-admit.action": "/echecks/aval/update/pending",
            "echeq.aval-repudiate.action": "/echecks/aval/update/pending",
            "rapipago.operation.confirm": `/payments/${routeParam}/pending`,
            "fcem.action": `/creditBills/${routeParam}/pending`,
            "unsecured.loans.application.send": "/requestUnsecuredLoan/transaction",
            "unsecured.loans.payOff.send": "/loans/cancelacionAnticipadaTicket",
            "cashout.send": "/cashOut/transaction",
            "change.status.debin.recurrency": "/debinPayments/action/action/pending",
            "debin.incoming.decline.send": "/debinPayments/reject/pending",
            "destinations.delete": "/contactDestination/delete/pending",
            "destinations.modify": "/contactDestination/modify/pending",
            "request.custom.loan": "/requestCustomLoan/transaction",
            "veps.process.payment": "/vepPayments/newPayment/transaction",
            "afip.services.process.payment": "/arcaServices/newPayment/transaction",
            "generate.mep.transfer": "/mep/transaction",
            "generate.comex.transfer": "/comex/transaction",
            "investmentFunds.addAccount.send": "/investmentFunds/accounts/add/transaction",
            "link.service": "/linkService/transaction",
            "generate.service.payment.link": "/newServicePayment/transaction",
            "directdebit.send": "/directDebit/transaction",
            "debin.scheduled.accept.send": `/scheduledDebin/${"accept"}/transaction`,
            "debin.scheduled.reject.send": `/scheduledDebin/${"reject"}/transaction`,
            "debin.scheduled.pause.send": `/scheduledDebin/${"pause"}/transaction`,
            "debin.scheduled.cancel.send": `/scheduledDebin/${"cancel"}/transaction`,
            "debin.scheduled.activate.send": `/scheduledDebin/${"activate"}/transaction`,
            "debin.chargeBack.send": "/debin/chargeBack/pending",
            "trxpl.chargeBack.send": "/debin/chargeBack/pending",
            "payroll.send": "/massPayroll/transaction",
            "actions.echeqs.multiple.send": "/echecks/action/cesion/pending",
            "cancel.endorse.echeq": "/echecks/action/cancelendorse/pending",
            "echeq.request.cac": "/echecks/cac/pending",
            "accept.return.rejected.echeq": "/echecks/rejected/return/accept/pending",
        };
    }
    if (status === transactionStatus.FINISHED) {
        return {
            "request.account.send": "/accounts/successTransaction",
            "request.agreement.send": "/accounts/agreements/successTransaction",
            "request.deposit.send": "/deposits/successTransaction",
            "request.accountsCheckbook.send": "/checks/successTransaction",
            "deposit.cancelRenewal.send": "/deposits/cancelRenewal/successTransaction",
            "emit.echeq.activity": "/echecks/emit/success",
            "transmit.cedip.send": "/cedip/transmit/success",
            "transmit.admit.cedip.send": "/cedip/transmit/success",
            "transmit.anulate.cedip.send": "/cedip/transmit/success",
            "transmit.repudiate.cedip.send": "/cedip/transmit/success",
            "endorse.echeq.activity": "/echecks/action/endorse/success",
            "cesion.echeq.activity": "/echecks/action/cesion/success",
            "actions.echeqs.send": "/echecks/action/transaction/success",
            "echeq.request-return.action": "/echecks/return/success",
            "accept.return.echeqs": "/echecks/return/success",
            "load.debin.recurrency": "/debin/emit/success",
            "generate.transfer": `/transfers/${"internal"}/success`,
            "generate.transfer.third.party": `/transfers/${"other"}/success`,
            "destinations.create": "/contactDestination/success",
            "transfers.third.parties": "/lotPayments/newPayment/success",
            "echeq.updateAmount": "/echecks/requestAmount/success",
            "debin.create.send": "/debinPayments/solicitDebin/success",
            "debin.incoming.accept.send": "/debinPayments/pay/success",
            "echeq.aval.solicitar": "/echecks/aval/solicit/success",
            "load.echeq.massive": "/massiveEchecks/newEcheq/success",
            "echeq.aval-anulate.action": "/echecks/aval/update/success",
            "echeq.aval-admit.action": "/echecks/aval/update/success",
            "echeq.aval-repudiate.action": "/echecks/aval/update/success",
            "rapipago.operation.confirm": `/payments/${routeParam}/success`,
            "fcem.action": `/creditBills/${routeParam}/success`,
            "unsecured.loans.application.send": "/requestUnsecuredLoan/transaction",
            "unsecured.loans.payOff.send": "/loans/cancelacionAnticipadaTicket",
            "cashout.send": "/cashOut/transaction",
            "change.status.debin.recurrency": "/debinPayments/action/action/success",
            "debin.incoming.decline.send": "/debinPayments/reject/success",
            "destinations.delete": "/contactDestination/delete/success",
            "destinations.modify": "/contactDestination/modify/success",
            "request.custom.loan": "/requestCustomLoan/transaction",
            "veps.process.payment": "/vepPayments/newPayment/transaction",
            "afip.services.process.payment": "/arcaServices/newPayment/transaction",
            "generate.mep.transfer": "/mep/transaction",
            "productRequest.email.send": "/loans/otrosProductosSucccessTicket",
            "generate.comex.transfer": "/comex/transaction",
            "investmentFunds.addAccount.send": "/investmentFunds/accounts/add/transaction",
            "link.service": "/linkService/transaction",
            "generate.service.payment.link": "/newServicePayment/transaction",
            "directdebit.send": "/directDebit/transaction",
            "debin.scheduled.accept.send": `/scheduledDebin/${"accept"}/transaction`,
            "debin.scheduled.reject.send": `/scheduledDebin/${"reject"}/transaction`,
            "debin.scheduled.pause.send": `/scheduledDebin/${"pause"}/transaction`,
            "debin.scheduled.cancel.send": `/scheduledDebin/${"cancel"}/transaction`,
            "debin.scheduled.activate.send": `/scheduledDebin/${"activate"}/transaction`,
            "debin.chargeBack.send": "/debin/chargeBack/success",
            "trxpl.chargeBack.send": "/debin/chargeBack/success",
            "payroll.send": "/massPayroll/transaction",
            "cancel.endorse.echeq": "/echecks/action/cancelendorse/success",
            "actions.echeqs.multiple.send": "/echecks/action/cesion/success",
            "echeq.request.cac": "/echecks/cac/success",
            "accept.return.rejected.echeq": "/echecks/rejected/return/accept/success",
        };
    }
    if (status === transactionStatus.CANCELLED) {
        return {
            "request.account.send": "/accounts/cancelledTransaction",
            "request.agreement.send": "/desktop",
            "emit.echeq.activity": "/echecks/emit/failed",
            "request.deposit.send": "/desktop",
            "request.accountsCheckbook.send": "/desktop",
            "deposit.cancelRenewal.send": "/desktop",
            "transfers.third.parties": "/lotPayments/newPayment/cancelled",
            "generate.transfer": `/transfers/${"internal"}/cancelled`,
            "generate.transfer.third.party": `/transfers/${"other"}/cancelled`,
            "echeq.updateAmount": "/echecks/requestAmount/cancelled",
            "request.custom.loan": "/requestCustomLoan/transaction",
            "veps.process.payment": "/vepPayments/newPayment/transaction",
            "unsecured.loans.application.send": "/requestUnsecuredLoan/transaction",
            "afip.services.process.payment": "/arcaServices/newPayment/transaction",
            "generate.mep.transfer": "/mep/transaction",
            "generate.comex.transfer": "/comex/transaction",
            "investmentFunds.addAccount.send": "/investmentFunds/accounts/add/transaction",
            "generate.service.payment.link": "/newServicePayment/transaction",
            "directdebit.send": "/directDebit/transaction",
            "debin.scheduled.accept.send": `/scheduledDebin/${"accept"}/transaction`,
            "debin.scheduled.reject.send": `/scheduledDebin/${"reject"}/transaction`,
            "debin.scheduled.pause.send": `/scheduledDebin/${"pause"}/transaction`,
            "debin.scheduled.cancel.send": `/scheduledDebin/${"cancel"}/transaction`,
            "debin.scheduled.activate.send": `/scheduledDebin/${"activate"}/transaction`,
            "cesion.echeq.activity": "/echecks/cesion/transaction",
            "actions.echeqs.send": "/echecks/action/transaction/cancelled",
            "debin.chargeBack.send": "/debin/chargeBack/cancelled",
            "payroll.send": "/massPayroll/transaction",
            "endorse.echeq.activity": "/echecks/action/endorse/cancelled",
            "cancel.endorse.echeq": "/echecks/action/cancelendorse/cancelled",
            "actions.echeqs.multiple.send": "/echecks/action/cesion/cancelled",
            "echeq.request.cac": "/echecks/cac/cancelled",
            "accept.return.rejected.echeq": "/echecks/rejected/return/accept/cancelled",
        };
    }
    if (status === transactionStatus.FAILED) {
        return {
            "request.account.send": "/accounts/failed",
            "request.deposit.send": "/deposits/failedTransaction",
            "request.agreement.send": "/accounts/agreements/failedTransaction",
            "emit.echeq.activity": "/echecks/emit/failed",
            "transmit.cedip.send": "/cedip/transmit/failed",
            "transmit.admit.cedip.send": "/cedip/transmit/failed",
            "transmit.anulate.cedip.send": "/cedip/transmit/failed",
            "transmit.repudiate.cedip.send": "/cedip/transmit/failed",
            "echeq.aval.solicitar": "/echecks/aval/solicit/failed",
            "actions.echeqs.send": "/echecks/action/transaction/failed",
            "generate.transfer": `/transfers/${"internal"}/failed`,
            "generate.transfer.third.party": `/transfers/${"other"}/failed`,
            "destinations.create": "/contactDestination/failed",
            "transfers.third.parties": "/lotPayments/newPayment/failed",
            "load.echeq.massive": "/massiveEchecks/newEcheq/failed",
            "rapipago.operation.confirm": `/payments/${routeParam}/failed`,
            "fcem.action": `/creditBills/${routeParam}/failed`,
            "unsecured.loans.application.send": "/requestUnsecuredLoan/transaction",
            "unsecured.loans.payOff.send": "/loans/cancelacionAnticipadaTicket",
            "cashout.send": "/cashOut/transaction",
            "debin.incoming.decline.send": "/debinPayments/reject/failed",
            "debin.create.send": "/debinPayments/solicitDebin/failed",
            "destinations.delete": "/contactDestination/delete/failed",
            "destinations.modify": "/contactDestination/modify/failed",
            "veps.process.payment": "/vepPayments/newPayment/transaction",
            "afip.services.process.payment": "/arcaServices/newPayment/transaction",
            "generate.mep.transfer": "/mep/transaction",
            "generate.comex.transfer": "/comex/transaction",
            "investmentFunds.addAccount.send": "/investmentFunds/accounts/add/transaction",
            "link.service": "/linkService/transaction",
            "generate.service.payment.link": "/newServicePayment/transaction",
            "directdebit.send": "/directDebit/transaction",
            "debin.scheduled.accept.send": `/scheduledDebin/${"accept"}/transaction`,
            "debin.scheduled.reject.send": `/scheduledDebin/${"reject"}/transaction`,
            "debin.scheduled.pause.send": `/scheduledDebin/${"pause"}/transaction`,
            "debin.scheduled.cancel.send": `/scheduledDebin/${"cancel"}/transaction`,
            "debin.scheduled.activate.send": `/scheduledDebin/${"activate"}/transaction`,
            "cesion.echeq.activity": "/echecks/cesion/transaction",
            "debin.chargeBack.send": "/debin/chargeBack/failed",
            "trxpl.chargeBack.send": "/debin/chargeBack/cancelled",
            "payroll.send": "/massPayroll/transaction",
            "debin.incoming.accept.send": "/debinPayments/pay/failed",
            "endorse.echeq.activity": "/echecks/action/endorse/failed",
            "cancel.endorse.echeq": "/echecks/action/cancelendorse/failed",
            "actions.echeqs.multiple.send": "/echecks/action/cesion/failed",
            "echeq.request.cac": "/echecks/cac/failed",
            "accept.return.rejected.echeq": "/echecks/rejected/return/accept/failed",
        };
    }
    if (status === transactionStatus.SCHEDULED) {
        return {
            "generate.transfer": `/transfers/${"internal"}/schedule`,
            "generate.transfer.third.party": `/transfers/${"other"}/schedule`,
        };
    }

    if (status === transactionStatus.PROCESSING) {
        return {
            "transfers.third.parties": "/lotPayments/newPayment/processing",
            "load.echeq.massive": "/massiveEchecks/newEcheq/processing",
            "fcem.action": `/creditBills/${routeParam}/processing`,
            "veps.process.payment": "/vepPayments/newPayment/transaction",
            "afip.services.process.payment": "/arcaServices/newPayment/transaction",
        };
    }
    if (status === transactionStatus.DRAFT) {
        return {
            "generate.transfer.third.party": `/transfers/${"other"}/draft`,
        };
    }
    return "";
};

export const productTicketinBackoffice = [
    "echeq.admit.action",
    "echeq.deposit.action",
    "echeq.anulate-echeq.action",
    "productRequest.email.send",
    "echeq.anulate-cesion.action",
    "unsecured.loans.payOff",
    "simulate.echeq.discounts",
    "administration.signatures.create.send",
    "administration.signatures.modify.send",
    "administration.signatures.delete.send",
    "core.forms.send",
    "administration.advanced.group.modify.send",
    "echeq.repudiate.action",
    "echeq.admit-cesion.action",
    "echeq.repudiate-cesion.action",
    "echeq.rescue.action",
    "echeq.anulate-endorse.action",
];

export const fixTxPageByActivityinBackoffice = [
    ...productTicketinBackoffice,
    "unsecured.loans.payOff.send",
    "emit.echeq.activity",
    "transmit.cedip.send",
    "echeq.updateAmount",
    "load.echeq.discounts",
    "openLot.ownEcheq.send",
    "debin.incoming.decline.send",
];

export default getRouteByState;
